import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      RECIPE: "Oppskrift",
    },
    se: {
      RECIPE: "Recept",
    },
    dk: {
      RECIPE: "Opskrift",
    },
  } as const
)[language];
